import React, { useState, useEffect } from 'react';
import MapService from './utils/MapService';
import MapList from './components/bper-map-list';
import SubsidiaryDetail from './components/bper-subsidiary-detail';
import ClosestSubsidiaries from './components/bper-closest-subsidiaries';
import './app.scss';
import parseHTML from "html-react-parser";

const DEFAULT_LANGUAGE = "it";
const DEFAULT_BANK = "05387";

export default function App({ config, portlet }) {
	const language = config ? config.language + "" : DEFAULT_LANGUAGE;
	const bank = config ? config.abicode + "" : DEFAULT_BANK;
	const groupId = parseInt(config ? config.groupId : 0);

	const [translations, setTranslations] = useState(undefined);
	const [ready, setReady] = useState(false);
	const [currentSubsidiary, setCurrentSubsidiary] = useState(config ? config.currentSubsidiary : undefined);
	const [regionProvince, setRegionProvince] = useState({ region: config ? config.currentRegion : undefined, province: config ? config.currentProvince : undefined });


	useEffect(() => {
		getTranslations(language, bank);
		detectPage();
	}, []);

	const getTranslations = (language, bank) => {
		MapService.getTranslations(language, bank).then((response) => {
			setTranslations(response);
		});
	};

	const detectPage = () => {
		const pathname = window.location.pathname;
		const match = "/agenzia-";
		const indexOf = pathname.indexOf(match) + match.length;

		if (pathname.indexOf(match) >= 0) {
			let scheda = pathname.substring(indexOf);
			const indexOfEnd1 = scheda.indexOf("/");
			if (scheda.indexOf("/") > 0) {
				scheda = scheda.substring(0, indexOfEnd1);
			}
			const indexOfEnd2 = scheda.indexOf("/");
			if (scheda.indexOf("?") > 0) {
				scheda = scheda.substring(0, indexOfEnd2);
			}
			if (scheda !== "") {
				setCurrentSubsidiary(scheda);
			}
		}

		if ((config && config.currentRegion === "") || config === undefined) {
			//solo se non fa match da JSP provo match da react
			const matchRegion = "/dove-siamo/";
			const indexOfRegion = pathname.indexOf(matchRegion) > -1 ? pathname.indexOf(matchRegion) + matchRegion.length : -1;
			if (indexOfRegion > -1) {
				const regionProvince = pathname.substring(indexOfRegion).split("/");
				const region = regionProvince[0];
				const province = regionProvince[1];
				setRegionProvince({
					region: region,
					province: province
				});
			}
		}
		
		setReady(true);
	}

	return (
		<>
			{translations && ready  &&
				<>
					{portlet === "search" &&
						<>
							{currentSubsidiary && currentSubsidiary !== ""
								?
									<SubsidiaryDetail
										bank={bank}
										groupId={groupId}
										translations={translations}
										subsidiaryId={currentSubsidiary}
									/>
								:
									<MapList
										bank={bank}
										translations={translations}
										groupId={groupId}
										currentBaseRegion={regionProvince.region}
										currentBaseProvince={regionProvince.province}
									/>
							}
						</>
					}
					{portlet === "closest" && currentSubsidiary && currentSubsidiary !== ""  &&
						<ClosestSubsidiaries
							bank={bank}
							translations={translations}
							groupId={groupId}
							subsidiaryId={currentSubsidiary}
						/>
					}
				</>
			}
		</>
	);
}